<dashboard-dialog-frame header='Directly Assign Specialist' [dialogRef]='dialogRef' [actions]="actions()">

	<div class="p-3">
		<person-finder-widget searchLabel='Search Person' (selectedRowId)="setSelectedPersonId($event)"></person-finder-widget>

		<p class="mt-3"><b>NOTE:</b> This is for urgent use only. This action allows you to bypass the requirement of a Specialist Sign-up to assign them to a Class Session.</p>
		<p><b>IMPORTANT:</b> This will not check if the Specialist has already been assigned to a conflicting class session. Please check manually!</p>

		@if(specialistAvailability(); as specialist) {
		<div class="mt-4 mb-3">
			@if(!specialist.volunteerId) {
			<p class="text-danger">Selected person does not have a Volunteer record</p>

			} @else if(specialist.approvalIssues; as approvalIssues) {
			<p class="text-danger mb-2">Selected person is not in a valid status. Please update their Volunteer details for the following to continue:</p>
			<ul class="text-danger">
				@if(!approvalIssues.isVolunteerApproved) {
				<li>Volunteer record must be marked "Approved"</li>
				}
				@if(!approvalIssues.isVolunteerInClassApproved) {
				<li>Must be In-Class Specialist Approved</li>
				}
				@if(!approvalIssues.isApprovedForTopic){
				<li>Must be Approved for {{dialogContext.data?.topicName}}</li>
				}
				@if(!approvalIssues.isApprovedForLanguage){
				<li>Must be Approved for {{dialogContext.data?.language}}</li>
				}
			</ul>
			} @else if (specialist.volunteerId && !specialist.approvalIssues) {
			<p class="text-success">Looks good! Continue adding this person as Specialist for {{dialogContext.data?.topicName}}?</p>
			}
		</div>
		}
	</div>

</dashboard-dialog-frame>